import { MdFlight } from 'react-icons/md';
import CircleIcon from 'components/CircleIcon';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import {
  diffInHoursAndMinutes,
  displayDate,
  displayTime,
  getStringValue,
} from 'shared/helpers/common';
import { getAllFlightSegments } from 'shared/helpers/quoteBooking';
import FlightsItem from './FlightsItem';

export default function Flights({ flightList = [] }) {
  const allFlightSegments = getAllFlightSegments(flightList);
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <MdFlight style={{ fill: primaryColour }} />
        </CircleIcon>
        <SectionLabel label="Travel" className="ml-[10px] mt-1" />
      </div>
      {allFlightSegments?.map?.(
        (
          {
            id,
            direction,
            departureAirport = {},
            arrivalAirport = {},
            flightNumber,
            // checkinDate,
            departureDate,
            arrivalDate,
            arrivalTerminal,
            departureTerminal,
            airline,
          },
          index,
        ) => (
          <FlightsItem
            key={id || `${index + 1}-id`}
            index={index}
            isOutbound={direction !== 'INBOUND'}
            travelTime={diffInHoursAndMinutes(arrivalDate, departureDate, 'HR')}
            departureAirportCode={getStringValue(departureAirport?.code)}
            departureAirportName={getStringValue(departureAirport?.name)}
            departureTerminal={departureTerminal}
            arrivalAirportCode={getStringValue(arrivalAirport?.code)}
            arrivalAirportName={getStringValue(arrivalAirport?.name)}
            arrivalTerminal={arrivalTerminal}
            departureTime={displayTime(departureDate)}
            departureDate={displayDate(departureDate, '-', undefined, true)}
            arrivalTime={displayTime(arrivalDate)}
            arrivalDate={displayDate(arrivalDate, '-', undefined, true)}
            flightNumber={flightNumber}
            // checkInDate={displayDate(checkinDate, '-', DATE_TIME_FORMAT)}
            airline={airline}
          />
        ),
      )}
    </>
  );
}
